import { Box, List, Stack, styled } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { FC } from "react";

export const SkeletonRow = () => (
  <Skeleton
    sx={(theme) => ({
      width: "100%",
      height: "60px",
      bgcolor: theme.palette.surfaceLight30.main,
      borderRadius: "0.25px",
    })}
    test-label="skeleton-row"
  />
);

interface SkeletonTableProps {
  rows: number;
}

export const SkeletonTable: FC<SkeletonTableProps> = ({ rows }) => {
  return (
    <Box
      className="skeleton"
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: `${rows * 60}px`,
        marginTop: "20px",
      }}
    >
      {[...Array(rows)].map((val, idx) => (
        <SkeletonRow key={idx} />
      ))}
    </Box>
  );
};

export const SkeletonTestRunItem = () => (
  <Skeleton
    sx={(theme) => ({
      width: "100%",
      height: "220px",
      bgcolor: theme.palette.surfaceLight30.main,
      borderRadius: "0.25px",
    })}
  />
);

const ListStyled = styled(List)({
  width: "90%",
});

export const SkeletonTestRuns: FC<SkeletonTableProps> = ({ rows }) => {
  return (
    <Stack sx={{ alignItems: "center" }}>
      <ListStyled>
        {[...Array(rows)].map((_, idx) => (
          <SkeletonTestRunItem key={idx} />
        ))}
      </ListStyled>
    </Stack>
  );
};

const SkeletonBackfillRunItem = styled(Skeleton)(({ theme }) => ({
  marginTop: "2em",
  width: "90%",
  height: "100px",
  backgroundColor: theme.palette.surfaceLight30.main,
  borderRadius: "0.25px",
}));

export const SkeletonBackfillRuns: FC<SkeletonTableProps> = ({ rows }) => {
  return (
    <Stack sx={{ alignItems: "center", justifyContent: "center" }}>
      <ListStyled>
        {[...Array(rows)].map((_, idx) => (
          <SkeletonBackfillRunItem key={idx} />
        ))}
      </ListStyled>
    </Stack>
  );
};
